import siteInfo from "@/constants/siteInfo";
import sendGAEvent from "@/utils/gaEvent";
import { useRouter } from "next/router";
import SVG from "react-inlinesvg";

const NewsList = ({
  contentData = null,
  isRajasthan = false,
  isMadhya = false,
  isHR = false,
  isUP = false,
  isBH = false,
  isUK = false,
}) => {
  const router = useRouter();
  let websiteUrl = process.env.NEXT_PUBLIC_WEBSITE_URL;
  return (
    <div className="my-5">
      <div className="flex">
        <div
          className={`${
            isRajasthan
              ? "text-rajasthanDark"
              : isMadhya
              ? "text-mpDark"
              : isHR
              ? "text-hrDark"
              : isBH
              ? "text-biharDark"
              : isUP
              ? "text-upDark"
              : isUK
              ? "text-ukDark"
              : "text-primary"
          } font-bold text-lg`}
        >
          {/* {contentData?.info?.icon && <SVG
            className="w-4 h-4 inline mr-2"
            src={contentData?.info?.icon}
          />} */}
          <h2>{contentData?.info?.name ?? "ट्रेंडिंग न्यूज़"}</h2>
        </div>
        <div className="text-slate-500 font-normal text-sm ml-auto">
          <a
            title={contentData?.info?.name ?? "ट्रेंडिंग न्यूज़"}
            href={contentData?.info?.canonical_url ?? "/"}
          >
            <span className="flex items-center">
              और देखें
              <SVG
                className="w-4 h-4 inline ml-2  mt-[-2px]"
                src="/assets/icons/svg/rightArrowRound.svg"
              />
            </span>
          </a>
        </div>
      </div>

      <div className="my-2">
        {contentData?.content?.map((item, index) =>
          index === 0 ? (
            <div
              onClick={() => {
                sendGAEvent({
                  eventName: "HomePage-NewsClickFromTrendingRHS",
                  pageTitle: item?.title_short,
                  pageLocation: `${websiteUrl}${item?.canonical_url}`,
                });
              }}
              key={index}
              className="flex flex-col items-center"
            >
              <div className="relative">
                <a
                  href={websiteUrl + item?.canonical_url ?? ""}
                  className="w-full"
                >
                  <img
                    src={`${item?.image_small}?size=360:203`} // Fallback image
                    // srcSet={`${item?.image_small}?size=720:406 2x, ${item?.image_small}?size=480:271 1.5x, ${item?.image_small}?size=360:203 1x`} // Different resolutions
                    // sizes="(max-width: 480px) 360px, (max-width: 720px) 480px, 720px" // Specify sizes for different viewport widths
                    alt={item?.image_small_alt_text || siteInfo?.siteName}
                    loading="lazy"
                    title={item?.image_title}
                    width="360"
                    height="203"
                    className="w-full h-auto rounded-md object-fill"
                  />
                </a>
                {/* Conditionally render the play icon if the content type is video */}
                {item?.content_type === "video" && (
                  <a href={item?.canonical_url ?? ""}>
                    <div
                      role="button"
                      className="absolute inset-0 flex justify-center items-center"
                    >
                      <SVG
                        className="w-8 h-8"
                        src="/assets/icons/svg/play-media.svg"
                      />
                    </div>
                  </a>
                )}
              </div>

              <a href={item?.canonical_url} className="w-full">
                <h3
                  className={`my-2 mt-1 flex-1 line-clamp-3 text-left text-md font-bold`}
                  dangerouslySetInnerHTML={{ __html: `${item?.title_short}` }}
                />
              </a>
            </div>
          ) : (
            <div
              onClick={() => {
                sendGAEvent({
                  eventName: "HomePage-NewsClickFromTrendingRHS",
                  pageTitle: item?.title_short,
                  pageLocation: `${websiteUrl}${item?.canonical_url}`,
                });
              }}
              key={index}
              className="flex items-center my-2"
            >
              {/* <img
                src={`${item?.image_small}?size=280:180`}
                alt={
                  item?.image_small_alt_text
                    ? item?.image_small_alt_text
                    : siteInfo?.siteName
                }
                loading="lazy"
                role="button"
                title={item?.image_title}
                onClick={() => {
                  router.push(item?.canonical_url);
                }}
                className="w-2/5 h-auto rounded-md object-cover"
              /> */}

              <div className="relative">
                <a href={websiteUrl + item?.canonical_url ?? ""}>
                  <img
                    className="h-16 min-w-[114px] md:h-16 sm:h-16  rounded-md"
                    src={`${item?.image_small}?size=320:180`} // Fallback image
                    title={item?.image_title}
                    alt={item?.image_small_alt_text || siteInfo?.siteName}
                    onClick={() => {
                      router.push(item?.canonical_url);
                    }}
                    loading="lazy"
                    height={80}
                    width={140}
                    role="button"
                  />
                </a>
                {/* Conditionally render the play icon if the item type is video */}
                {item?.content_type === "video" && (
                  <a href={item?.canonical_url ?? ""}>
                    <div
                      role="button"
                      className="absolute inset-0 flex justify-center items-center"
                    >
                      <SVG
                        className="w-6 h-6"
                        src="/assets/icons/svg/play-media.svg"
                      />
                    </div>
                  </a>
                )}
              </div>

              <a href={item?.canonical_url}>
                <h3
                  className="flex-1 mx-2 line-clamp-3 font-bold text-md"
                  dangerouslySetInnerHTML={{ __html: `${item?.title_short}` }}
                />
              </a>
            </div>
          )
        )}
      </div>
    </div>
  );
};

export default NewsList;
